import { Icon } from "~components";
import { Css } from "~generated/css";
import { Maybe, PotentialOperation2 } from "~generated/graphqlTypes";
import { isDefined, useTestIds } from "~utils";

export type UserWarningProps = {
  title: string;
  disabledReasons?: Maybe<PotentialOperation2>[];
};

/**
 * This component is used to format warning messages with the conventional warning icon.
 * The static `title` is displayed first then any optional potential operation disabled
 * reasons via `disabledReasons` are displayed after it  .
 */
export function UserWarning(props: UserWarningProps) {
  const { title, disabledReasons = [] } = props;
  const tid = useTestIds(props, "user-warning");

  const maybeDisabledMessages = disabledReasons
    .filter(isDefined)
    .flatMap((operation) => operation.disabledReasons?.map((r) => r.message) ?? []);

  return (
    <div css={Css.df.gapPx(3).mt3.ais.ifMobile.mt1.$}>
      <div>
        <Icon name="warning-icon" />
      </div>
      <p css={Css.t12.gray.$} {...tid.warningMessage}>
        {title}
        {maybeDisabledMessages.length > 0 ? ` ${maybeDisabledMessages.join(", ")}` : ""}
      </p>
    </div>
  );
}
